export default __webpack_public_path__ + "static/media/icon-GNS_v2.43bcc479.svg";